import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';
import {
    canManageLateSubmissionPolicies,
    canViewLateSubmissionDeductionsReport,
} from '@/policies/LateSubmissionPolicyPolicy.js';

const meta = {
    title: 'Late Submission Policies',
    middleware: [GateKeeperMiddleware],
    ability: ({ gateKeeper }) => canManageLateSubmissionPolicies(gateKeeper.user),
    dataTablePage: true,
};

export default [
    {
        path: '/administration/late-submission-policies',
        name: 'late-submission-policies-index',
        component: () => import('@/pages/administration/late-submission-policies/PolicyIndex.vue'),
        meta: { ...meta },
    },
    {
        path: '/administration/late-submission-policies/deductions-report',
        name: 'late-submission-deductions-report',
        component: () => import('@/pages/administration/late-submission-policies/DeductionsReport.vue'),
        meta: {
            ...meta,
            title: 'Late Submission Deductions',
            ability: ({ gateKeeper }) => canViewLateSubmissionDeductionsReport(gateKeeper.user),
        },
    },
    {
        path: '/administration/late-submission-policies/:policyId',
        name: 'late-submission-policies-show',
        component: () => import('@/pages/administration/late-submission-policies/PolicyDetail.vue'),
        meta: { ...meta, title: 'Late Submission Policy' },
        props: true,
    },
];
